// extracted by mini-css-extract-plugin
export default {"paperContainerPaper":"PaperContainer_paperContainerPaper__FhAXh","paperContainerContainer":"PaperContainer_paperContainerContainer__Iew6C"};